import React, { FC } from 'react';
import styles from './decisions_legislation_snippet_components.module.scss';
import { Hyperlink } from '../../../components/Hyperlink';
import { buildUrlWithParameters } from '../../../utils/url-utils/urlUtils';
import { useUser } from '../../../user/useUser';

export const DecisionsLegislationSnippetContainer: FC = ({ children }) => (
  <div className={styles.container}>{children}</div>
);

export const DecisionsLegislationSnippetTitle: FC = ({ children }) => (
  <div className={styles.title}>{children}</div>
);

export const DecisionsLegislationSnippetList: FC = ({ children }) => (
  <ul className={styles.list}>{children}</ul>
);

type LinkProps = {
  index: number;
  url: string;
  source: string;
  onClick: () => void;
};

export const DecisionsLegislationSnippetLink: FC<LinkProps> = ({
  children,
  index,
  url,
  source,
  onClick,
}) => {
  const { accessPremium } = useUser();
  return (
    <Hyperlink
      data-doctrine-popover
      data-decision={index}
      className={styles.link}
      {...(accessPremium
        ? {
            href: buildUrlWithParameters(url, {
              source,
            }),
          }
        : { onClick })}
    >
      {children}
    </Hyperlink>
  );
};
